import {Form} from "react-bootstrap";
import React from "react";

export default ({text, hasHint, hint}) =>
    (
        <Form.Label className="form__label">
            {`${text} `} {hasHint && <span className="form__label-hint">{hint}</span>}
        </Form.Label>
    )